/* =======================================================================
   APP.JS — File principale: definisce le pagine (rotte) del sito
   =======================================================================
   Ogni <Route> è una pagina del sito.
   - path: l'indirizzo nell'URL (es. "/storia" → ../#/storia)
   - element: il file della pagina da mostrare

   Per AGGIUNGERE una pagina:
     1. Crea un file in src/pages/, es. "NuovaPagina.jsx"
     2. Importalo qui in alto
     3. Aggiungi una nuova <Route path="/nome" element={<NuovaPagina />} />
     4. Aggiungi la voce di menù in src/components/site/Header.jsx (array NAV_LINKS)

   ⚠️ Usiamo BrowserRouter (URL "puliti" tipo /storia, /menu).
   Sull'hosting serve un file di rewrite (.htaccess su Apache/cPanel,
   _redirects su Netlify) che reindirizza tutte le rotte a index.html.
   Entrambi sono già presenti nella cartella build/.
   ======================================================================= */

import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/site/Layout";
import HomePage from "@/pages/HomePage";
import StoryPage from "@/pages/StoryPage";
import MenuPage from "@/pages/MenuPage";
import GalleryPage from "@/pages/GalleryPage";
import VisitPage from "@/pages/VisitPage";
import LinksPage from "@/pages/LinksPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          {/* Pagina nascosta: accessibile SOLO via /links, fuori dal Layout
              (niente header/footer attorno) */}
          <Route path="/links" element={<LinksPage />} />

          {/* Tutte le altre pagine sono dentro al Layout (header + footer) */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/storia" element={<StoryPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/galleria" element={<GalleryPage />} />
            <Route path="/visitaci" element={<VisitPage />} />
            <Route path="/contatti" element={<VisitPage />} />
            <Route path="*" element={<HomePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
